module.exports = __webpack_public_path__ + "img/STERiJECT_02_4.8d4697d4.png";